import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";


class Header extends Component {
  render() {
    if (!this.props.data) return null;

    const description = this.props.data.description;
    let config = {
      body: "./images/slice6.png",
      position: {x:0,y:932,width: window.innerWidth,height:0},
      // color: ["random", "#ff0000"],
      num: [0,2], //num of flowers
      rps: 1, // speed
      radius: [2, 9],
      life: 14, // how long on screen
      v: 2,
      tha: .5,
      rotate: [1, 1.5],
      alpha: 1,
      // scale: [1, 0.6],
      cross: "bround", // cross or bround
      random: null,  // or null,
      g: -.15,    // gravity
      // f: [0, 0], // force
      // onParticleUpdate: (ctx, particle) => {
      //     ctx.beginPath();
      //     ctx.rect(particle.p.x, particle.p.y, particle.radius * 2, particle.radius * 2);
      //     ctx.fillStyle = particle.color;
      //     ctx.fill();
      //     ctx.closePath();
      // }
    }

    return (
      <header id="home">
        <ParticlesBg bg={true} type="custom" config={config} />

        <div className="row banner">
          <div className="banner-text">
            
            <Fade bottom>
              <img src="./images/refresh-white-centered.png"></img>
            </Fade>
            <Fade bottom>
              <h2 className="responsive-headline" >&nbsp;</h2>
              {/* <h2 className="responsive-headline" >{topdescription}</h2> */}


            </Fade>
            <Fade bottom duration={1200}>
              <h3>{description}</h3>
            </Fade>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#contact">
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
